import React from 'react';
import { GlowingEffect } from './GlowingEffect';

/**
 * A wrapper that adds a glowing effect to any component
 */
export function GlowingWrapper({ children, className = '' }) {
  return (
    <div className={`relative ${className}`} style={{ 
      borderRadius: '16px',
      height: '100%', // Ensure all wrappers have the same height
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto', // Take up all available space but don't grow beyond content
      pointerEvents: 'auto', // Ensure clicks pass through
      position: 'relative', // Ensure positioning context for absolute elements
      overflow: 'visible', // Allow content to overflow for descriptions
      zIndex: 1, // Ensure proper stacking
      minHeight: '350px' // Minimum height to match the box column height
    }}>
      <GlowingEffect
        spread={20} // Smaller spread for border-like effect
        glow={true}
        disabled={false}
        proximity={120} // Higher proximity - detect the mouse from farther away
        inactiveZone={0.01}
        borderWidth={1} // Thinner border
      />
      <div style={{ 
        position: 'relative', 
        zIndex: 2, 
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        pointerEvents: 'auto' // Explicitly ensure pointer events work
      }}>
        {children}
      </div>
    </div>
  );
} 